import { render, staticRenderFns } from "./size-range-edit.vue?vue&type=template&id=1d37fe1b&scoped=true"
import script from "./size-range-edit.vue?vue&type=script&lang=js"
export * from "./size-range-edit.vue?vue&type=script&lang=js"
import style0 from "./size-range-edit.vue?vue&type=style&index=0&id=1d37fe1b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d37fe1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d37fe1b')) {
      api.createRecord('1d37fe1b', component.options)
    } else {
      api.reload('1d37fe1b', component.options)
    }
    module.hot.accept("./size-range-edit.vue?vue&type=template&id=1d37fe1b&scoped=true", function () {
      api.rerender('1d37fe1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/size-range-edit.vue"
export default component.exports